export const ENHANCE_COMMENT = "app/AISlice/ENHANCE_COMMENT";
export const ENHANCE_COMMENT_SUCCESS = "app/AISlice/ENHANCE_COMMENT_SUCCESS";
export const ENHANCE_COMMENT_FAILURE = "app/AISlice/ENHANCE_COMMENT_FAILURE";

export const ENHANCE_FEED = "app/AISlice/ENHANCE_FEED";
export const ENHANCE_FEED_SUCCESS = "app/AISlice/ENHANCE_FEED_SUCCESS";
export const ENHANCE_FEED_FAILURE = "app/AISlice/ENHANCE_FEED_FAILURE";
